// @ts-nocheck
/* eslint-disable */
import SceneFeature from "../feature";

export default class ScenePano extends SceneFeature {
	/**
	 * Vytvoreni zobrazeni panoramy nad scenou.
	 *
	 * @class ScenePano
	 * @extends SceneFeature
	 * @param  {Scene} scene Instace sceny
	 * @param  {Number} itemId ID ve scene
	 * @param  {Element} cont Kam se ma scena pripnout?
	 */
	constructor(scene, itemId, cont) {
		super(scene, itemId);

		this._cont = cont;
		this._marker = this._scene.createMarkerMapyPano(this._scene.coordsFromWGS84(14, 50));
		this._marker.decorateDraggable();
		this._place = null;
		this._ss = [];
		this._showOpts = null;
		this._camera = {
			yaw: 0,
			pitch: 0,
			fov: Math.PI * 0.4
		};
		this._timeline = null;

		// signal
		this._ss.push(this._scene.addListener("pano-change", e => {
			this._place = e.data.place;
			this._marker.setAngle(e.data.camera.yaw / Math.PI * 180);

			this._updateCamera(e.data.camera);
		}, this, this));
	}

	/**
	 * Destruktor.
	 */
	destroy() {
		this._scene.removeListeners(this._ss);

		super.destroy();
	}

	/**
	 * Informace o entite.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "ScenePano",
			type: "pano"
		};
	}

	/**
	 * Informace pro vizualizer provideru.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		let rd = super.getCreateData()

		rd.cont = this._cont;
		rd.marker = this._marker;
		rd.place = this._place;
		rd.showOpts = this._showOpts;
		rd.camera = this._camera;
		rd.timeline = this._timeline;

		return rd;
	}

	/**
	 * Zobrazeni pano sceny.
	 *
	 * @param {SMap.Pano.Place} place Misto k zobraeni
	 * @param {Object} opts Konfigurace kamery
	 * @param {Boolean} [options.blend=false] Pomocí animovaného prolnutí?
	 * @param {String || Number || Null} [options.yaw] Horizontální natočení: null => zachovat existující yaw, "auto" => použít spočítánou hodnotu pro panoramatu nebo se použije kappa, číslo = úhel (v radiánech)
	 * @param {String || Number || Null} [options.fov] Horizontální field of view: null => zachovat existující fov, "auto" => převzít ze scény, číslo = úhel (v radiánech)
	 * @param {String || Number || Null} [options.pitch] Vertikální natočení: null => zachovat existující pitch, "auto" => převzít ze scény, číslo = úhel (v radiánech)
	 */
	show(place, opts) {
		this._place = place;
		this._showOpts = opts;

		let coords = place.getCoords().toWGS84();
		this._marker.setCoords(this._scene.coordsFromWGS84(coords[0], coords[1]));

		this._onChange(this._scene.featureEvent("panoShow", true, true), arguments);
	}

	/**
	 * Nastaveni kamery.
	 *
	 * @param {Object} opts Objekt s klici:: fov, yaw, pitch.
	 */
	setCamera(opts) {
		this._updateCamera(opts);

		this._onChange(this._scene.featureEvent("panoSetCamera", true, true), arguments);
	}

	/**
	 * Aktualizace rozmeru panoramy.
	 */
	syncPort() {
		this._onChange(this._scene.featureEvent("panoSyncPort", true, true), arguments);
	}

	/**
	 * Vyvolani prekresleni sceny panoramy.
	 */
	redraw() {
		this._onChange(this._scene.featureEvent("panoRedraw", true, true), arguments);
	}
	/**
	 * Ziskani markeru pro panoramu.
	 *
	 * @return {SceneMarkerMapyPano}
	 */
	getMarker() {
		return this._marker;
	}

	/**
	 * Ziskani mista pro zobrazeni panoramy.
	 *
	 * @return {SMap.Pano.Place}
	 */
	getPlace() {
		return this._place;
	}

	/**
	 * Ziskani nastaveni kamery.
	 *
	 * @return {Object}
	 */
	getCamera() {
		return this._camera;
	}

	getDataUrl() {
		return this._scene.getPanoDataUrl(this);
	}

	addTimeline(el, cb) {
		this._timeline = {
			el,
			cb,
		};

		this._onChange(this._scene.featureEvent("panoAddTimeline", true, true), arguments);
	}

	/**
	 * Update dat kamery.
	 *
	 * @param  {Object} opts
	 * @private
	 */
	_updateCamera(opts) {
		for (let id in opts) {
			this._camera[id] = opts[id];
		}
	}
}
